import CronSerializer from './base';

export default class ProcessMonitor extends CronSerializer {
  // The API sends the process log in the `errors` key. Model.errors holds the
  // validation errors of a save, so the model attr has a different name.
  attrs = {
    processErrors: { key: 'errors' },
  };
}
